import React, { HTMLAttributes } from 'react';
import { Tooltip } from '../tooltips/Tooltip';
import { Icon } from '../icon/icon';
export interface MetrixBoxProps extends HTMLAttributes<HTMLDivElement> {
  contentText?: string;
  description?: string;
  hasInfo?: boolean;
  height?: string;
  header: string;
  headerIcon?: any;
  infoText?: string;
  infoBubbleWidth?: string;
  variant: 'overview' | 'details' | 'left' | 'right' | 'bottom' | 'top';
  width?: string;
  color?: string;
  offsetX?: string;
  offsetY?: string;
  unitText?: string;
  flipBubbleOrientation: boolean;
}

export const MetrixBox = ({
  className,
  contentText,
  description,
  header,
  headerIcon,
  hasInfo,
  height,
  infoText,
  infoBubbleWidth,
  variant,
  width,
  color,
  offsetX = '0px',
  offsetY = '0px',
  unitText,
  flipBubbleOrientation,
  ...rest
}: MetrixBoxProps) => {
  const renderOverviewMetrixBox =
    variant === 'overview' ? (
      <div
        className={`${!width || (width === '100%' && 'w-full')} ${
          !height && 'h-auto'
        } flex flex-col justify-center items-center text-center gap-[5px] border border-thryv-gray-light-400 py-[18px] px-[10px] ${
          className || ''
        }`}
        style={{ width: width || '', height: height || '' }}
        {...rest}
      >
        <h6
          className={`font-montserrat text-h3 font-semibold ${
            color ? `text-${color}` : 'text-thryv-black-500'
          }`}
        >
          {header}
          {unitText && (
            <span className="text-[#808080] text-[13px] font-normal leading-[18px]">
              {' '}
              {unitText}
            </span>
          )}
        </h6>
        <div className="w-full flex justify-center items-center font-open-sans font-normal">
          <span className="w-full flex justify-center gap-[5px] font-open-sans font-normal text-p-sm text-thryv-black-500">
            {description}
            <span className="relative">
              <span className="absolute">
                {hasInfo && (
                  <Tooltip
                    variant="top"
                    description={infoText}
                    width={infoBubbleWidth}
                    positioning={{ offsetX: '0px', offsetY: '0px' }}
                    descriptionFont="11px Open Sans, sans-serif"
                    flipBubbleOrientation={
                      flipBubbleOrientation && flipBubbleOrientation
                    }
                  >
                    <div className="pt-[2px] ">
                      <Icon
                        variant="infoCircle"
                        type="solid"
                        height="12px"
                        color="#BABABA"
                      />
                    </div>
                  </Tooltip>
                )}
              </span>
            </span>
          </span>
        </div>
      </div>
    ) : null;

  const renderDetailsMetrixBox =
    variant === 'details' ? (
      <div
        className={`${!width || (width === '100%' && 'w-full')} ${
          !height && 'h-auto'
        } flex flex-col justify-start items-start gap-[8px] border border-thryv-gray-light-400 p-3 ${
          className || ''
        }`}
        style={{ width: width || '', height: height || '' }}
        {...rest}
      >
        <div className="w-full flex justify-between items-center font-open-sans font-normal relative">
          <span className="w-full flex justify-start text-btn-links items-start gap-[5px] text-thryv-steel mt-[5px]">
            {header}
            <span className="relative">
              <span className="absolute">
                {hasInfo && (
                  <Tooltip
                    variant="top"
                    description={infoText}
                    width={infoBubbleWidth}
                    positioning={{ offsetX: '0px', offsetY: '0px' }}
                    descriptionFont="11px Open Sans, sans-serif"
                    flipBubbleOrientation={
                      flipBubbleOrientation && flipBubbleOrientation
                    }
                  >
                    <Icon
                      variant="infoCircle"
                      type="solid"
                      height="12px"
                      color="#BABABA"
                    />
                  </Tooltip>
                )}
              </span>
            </span>
            <span className="absolute top-0 right-0">{headerIcon}</span>
          </span>
        </div>
        <span
          className={`font-montserrat font-medium text-[19px] leading-[23px] ${
            color ? `text-${color}` : 'text-thryv-black-500'
          }`}
        >
          {contentText}
        </span>
      </div>
    ) : null;

  const renderCustomMetrixBox =
    variant !== 'overview' && variant !== 'details' ? (
      <div
        className={`${!width || (width === '100%' && 'w-full')} ${
          !height && 'h-auto'
        } flex flex-col justify-center items-center text-center gap-[5px] border border-thryv-gray-light-400 py-[18px] px-[10px] ${
          className || ''
        }`}
        style={{ width: width || '', height: height || '' }}
        {...rest}
      >
        <h6
          className={`font-montserrat text-h3 font-semibold ${
            color ? `text-${color}` : 'text-thryv-black-500'
          }`}
        >
          {header}
        </h6>
        <div className="w-full flex justify-center items-center font-open-sans font-normal">
          <span className="w-full flex justify-center gap-[5px] font-open-sans font-normal text-p-sm text-thryv-black-500">
            {description}
            <span className="relative">
              <span className="absolute">
                {hasInfo && (
                  <Tooltip
                    variant={variant}
                    description={infoText}
                    width={infoBubbleWidth}
                    positioning={{ offsetX, offsetY }}
                    descriptionFont="11px Open Sans, sans-serif"
                    flipBubbleOrientation={
                      flipBubbleOrientation && flipBubbleOrientation
                    }
                  >
                    <div className="pt-[2px] ">
                      <Icon
                        variant="infoCircle"
                        type="solid"
                        height="12px"
                        color="#BABABA"
                      />
                    </div>
                  </Tooltip>
                )}
              </span>
            </span>
          </span>
        </div>
      </div>
    ) : null;

  return (
    <>
      {renderOverviewMetrixBox}
      {renderDetailsMetrixBox}
      {renderCustomMetrixBox}
    </>
  );
};
